export const PRICING_MOBILE_BREAKPOINT = '800px';
export const PRICING_MID_BREAKPOINT = '1100px';
export const EMAIL_US_AT = 'hi@sudowrite.com';

export const DEV_ONBOARDING_SESSION_PRODUCT_ID = "test_6oEeWU2gF2AUdxe4gg";
export const PROD_ONBOARDING_SESSION_PRODUCT_ID = "5kA4hG2yiaes4Fy9AC";
